import styled from "styled-components";
import { mediaMaxWidth } from "../../../theme/mediaQueriesTemplates";

export const Wrapper = styled.div`
  background-color: #e4e5e7;
  width: 1150px;
  margin: 0 auto;
  padding: 65px 10px 10px 10px;

  .slick-track {
    margin: 0 auto;
    height: 590px;
  }

  ${mediaMaxWidth.smallDesktop} {
    .slick-center .plan {
      height: 550px;
      margin-top: 5px;
      box-shadow: 0 0 10px #cdcdcd;
    }
  }

  ${mediaMaxWidth.mediumDesktop} {
    width: calc(100vw - 60px);
    padding: 65px 0 10px 0;
  }

  ${mediaMaxWidth.tablet} {
    width: unset;
  }
`;

export const TermsInfo = styled.div`
  font-size: 0.95em;
  font-weight: 500;
  padding: 25px 0 50px 0;
  color: #7d7d7d;
  display: block;
  text-align: center;
  max-width: 700px;
  margin: 0 auto;

  ${mediaMaxWidth.tablet} {
    width: calc(100vw - 20px);
    padding: 80px 0 20px 0;
  }

  &.animated {
    animation-duration: 1s;
    animation-fill-mode: both;
  }

  @keyframes fadeIn {
    from {
      opacity: 0;
    }

    to {
      opacity: 1;
    }
  }

  &.fadeIn {
    animation-name: fadeIn;
  }

  &.delay {
    animation-delay: 0.5s;
  }
`;

export const TermsLink = styled.a`
  text-decoration: underline !important;
  color: #7d7d7d !important;
  padding-left: 2px;
  cursor: pointer;
  font-weight: 600;
`;
